import { cn } from "@newxsystems/shared";
import { DaylightCommonContent } from "../DaylightCommonContent/DaylightCommonContent";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import type { ICallToActionSplitProps } from "./CallToActionSplit.props";

const spans = {
  small: { content: "lg:col-span-8", media: "lg:col-span-4" },
  medium: { content: "lg:col-span-7", media: "lg:col-span-5" },
  large: { content: "lg:col-span-6", media: "lg:col-span-6" },
} as const;

export const CallToActionSplit = ({
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionSplitProps) => {
  const span = spans[imageWidth || "medium"];
  return (
    <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
      <div className={cn("flex flex-col", image ? span.content : "lg:col-span-12")}>
        <DaylightCommonContent
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
      </div>
      {image ? (
        <DaylightMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn("w-full", span.media)}
          media={image.image}
          sizes="(min-width: 1024px) 40vw, 100vw"
        />
      ) : null}
    </div>
  );
};

CallToActionSplit.displayName = "Content::CallToActionSplit";
